import React from 'react';

interface InputFieldProps {
  id: string;
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder: string;
  unit: string;
  icon?: React.ReactNode;
  error?: string;
}

export const InputField: React.FC<InputFieldProps> = ({
  id,
  label,
  value,
  onChange,
  placeholder,
  unit,
  icon,
  error
}) => {
  return (
    <div className="relative">
      <label 
        htmlFor={id} 
        className="block text-sm font-medium text-slate-700 mb-1"
      >
        {label} <span className="text-slate-500">({unit})</span>
      </label>
      
      <div className="relative rounded-md shadow-sm">
        {icon && (
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-slate-500">
            {icon}
          </div>
        )}
        
        <input
          type="number"
          id={id}
          name={id}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={`w-full py-2 ${icon ? 'pl-10' : 'pl-3'} pr-3 border ${
            error 
              ? 'border-red-300 focus:ring-red-500 focus:border-red-500' 
              : 'border-slate-300 focus:ring-blue-500 focus:border-blue-500'
          } rounded-md shadow-sm placeholder-slate-400 focus:outline-none focus:ring-2`}
          step="0.01"
          min="0"
        />
      </div>
      
      {error && (
        <p className="mt-1 text-sm text-red-600" id={`${id}-error`}>
          {error}
        </p>
      )}
    </div>
  );
};